<template lang="pug">
  tbody
    tr
      th {{ $t("ui.parlay") }}
      th {{ parlay_title }}
      td.text-center {{ parlay_upline_pt }}%
      td.text-center(v-show="isSearch") {{ parlay_account_pt }}%
      td.text-center(v-show="isSearch") {{ parlay_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ parlay_account_min }}%
    tr(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency)")
      th {{ $t("ui.parlay") }} MMO
      th {{ parlay_mmo_title }}
      td.text-center {{ parlay_mmo_upline_pt }}%
      td.text-center(v-show="isSearch") {{ parlay_mmo_account_pt }}%
      td.text-center(v-show="isSearch") {{ parlay_mmo_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ parlay_mmo_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      parlay_upline_min: 0,
      parlay_upline_max: 0,
      parlay_upline_pt: 0,
      parlay_account_pt: 0,
      parlay_upline_remaining: 0,
      parlay_account_min: 0,

      parlay_mmo_upline_min: 0,
      parlay_mmo_upline_max: 0,
      parlay_mmo_upline_pt: 0,
      parlay_mmo_account_pt: 0,
      parlay_mmo_upline_remaining: 0,
      parlay_mmo_account_min: 0
    }
  },
  computed: {
    parlay_title: function () {
      return this.$t("ui.parlay") + " (" + this.parlay_upline_min + "%-" + this.parlay_upline_max + "%)"
    },
    parlay_mmo_title: function () {
      return this.$t("ui.parlay") + " (" + this.parlay_mmo_upline_min + "%-" + this.parlay_mmo_upline_max + "%)"
    }
  }
}

</script>